import { type DraggableProvided } from 'react-beautiful-dnd'
import classnames from 'classnames'
import { type FC } from 'react'
import { Icon } from 'shared/ui'
import styles from 'widgets/ContactsDetails/ui/ContactsIntegrations/ui/styles.module.scss'
import { contactsDetailsGlobalStore } from 'widgets/ContactsDetails/store'
import type { IBlocksTypes } from 'widgets/ContactsDetails/store/contactsDetailsGlobalStore'

type IDraggingIconProps = {
  hideDraggingIcon?: boolean
  dragHandleProps: DraggableProvided['dragHandleProps']
  integrationBlockViewKey: IBlocksTypes
}

export const DraggingIcon: FC<IDraggingIconProps> = ({
  hideDraggingIcon,
  dragHandleProps,
  integrationBlockViewKey,
}) => {
  return (
    <div
      className={classnames(styles.iconDotsDrag, {
        [styles.hideDraggingIcon]: hideDraggingIcon,
      })}
      {...dragHandleProps}
    >
      <Icon
        icon={'dotsDrag'}
        fontSize={12}
        color={
          contactsDetailsGlobalStore.isOpenBlock(integrationBlockViewKey)
            ? undefined
            : 'var(--content-primary-tertiary)'
        }
      />
    </div>
  )
}
